function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var FilterFieldToggler = /*#__PURE__*/function () {
  function FilterFieldToggler(options) {
    _classCallCheck(this, FilterFieldToggler);
    this.selector = options.selector;
    this.fields = document.querySelectorAll('.' + options.selector) || null;
    this.fieldCheckCls = 'filter-field-checked', this.callBackClickFilter = options.callBackClickFilter;
  }
  _createClass(FilterFieldToggler, [{
    key: "getInputsRadio",
    value: function getInputsRadio() {
      return document.querySelectorAll(".".concat(this.selector, " input[type=radio]"));
    }
  }, {
    key: "getInputsCheckboxes",
    value: function getInputsCheckboxes() {
      return document.querySelectorAll(".".concat(this.selector, " input[type=checkbox]"));
    }
  }, {
    key: "getCheckedInputRadio",
    value: function getCheckedInputRadio() {
      return document.querySelector(".".concat(this.selector, " input[type=radio]:checked"));
    }
  }, {
    key: "getCheckedInputsCheckboxes",
    value: function getCheckedInputsCheckboxes() {
      return document.querySelectorAll(".".concat(this.selector, " input[type=checkbox]:checked"));
    }
  }, {
    key: "setRadioByName",
    value: function setRadioByName(name, attr) {
      var _this = this;
      this.clearRadioFields();
      this.getInputsRadio().forEach(function (inputRadio) {
        if (inputRadio.value === name) {
          inputRadio.checked = true;
          inputRadio.parentNode.parentNode.parentNode.classList.add(_this.fieldCheckCls);
        }
      });
    }
  }, {
    key: "handleClickOnFilter",
    value: function handleClickOnFilter(callback) {
      var _this2 = this;
      var self = this;
      this.fields.forEach(function (field) {
        var input = field.querySelector('input');
        input.addEventListener('click', function (e) {
          var inputsCheckboxChecked = _this2.getCheckedInputsCheckboxes();
          var inputRadioChecked = _this2.getCheckedInputRadio();
          if (input.type === 'checkbox') {
            field.classList.toggle(_this2.fieldCheckCls);
          }
          if (input.type === 'radio') {
            if (!field.classList.contains(_this2.fieldCheckCls)) {
              _this2.clearRadioFields();
              field.classList.add(_this2.fieldCheckCls);
            }
          }
          callback([inputsCheckboxChecked, inputRadioChecked]);
        });
      });
    }
  }, {
    key: "clearRadioFields",
    value: function clearRadioFields() {
      var _this3 = this;
      this.getInputsRadio().forEach(function (field) {
        var parent = field.parentNode.parentNode.parentNode;
        parent.classList.remove(_this3.fieldCheckCls);
      });
    }
  }]);
  return FilterFieldToggler;
}();
export { FilterFieldToggler as default };